import { GridValueFormatterParams } from "@mui/x-data-grid-pro";

const userFormatter = ({ value }: GridValueFormatterParams) => value && `${value.firstname} ${value.lastname}`;

export default userFormatter;